import { Injectable, inject } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { JwtService } from '../services/jwt.service';
import { SiteConfigService } from '../services/siteconfig.service';
import { AUTH_CREDENTIALS, AUTHED_REQ } from './http-context.tokens';

@Injectable()
export class HttpTokenInterceptor implements HttpInterceptor {
    private jwt = inject(JwtService);
    private scs = inject(SiteConfigService);


    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const headersConfig = {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        };
        const siteId = this.scs.id();
        const params = /.+\.json(\?.+)?$/.test(req.url) || req.params.has('site-id')? {} : {'site-id': siteId};

        // OB-7718 фаза 12: query-параметр access-token больше НЕ проставляется —
        // токен живёт в куке (httpOnly) и едет сам: запросы same-origin `/api`
        // (фаза 11), а на SSR куку пробрасывает IpInterceptor заголовком Cookie.
        // Content-Type: application/json оставлен намеренно — делает мутации
        // «непростыми» запросами, что дополнительно страхует от CSRF-форм.
        if (req.context.get(AUTH_CREDENTIALS)) {
            // auth-эндпоинты: реальный credentials-режим (нужен для кросс-доменного
            // легаси-входа, где браузер иначе выкинет Set-Cookie)
            return next.handle(req.clone({
                setParams: params,
                setHeaders: headersConfig,
            }));
        }

        if (req.withCredentials) {
            // маркер «персональный ответ» — по наличию сессии, а не токена;
            // withCredentials гасим (для same-origin куки едут и без него)
            if (this.jwt.hasSession()) {
                req.context.set(AUTHED_REQ, true);
            }
            return next.handle(req.clone({
                setParams: params,
                setHeaders: headersConfig,
                withCredentials: false,
            }));
        } else if (req.method != "JSONP") {
            const request = req.clone({
                setParams: params,
                setHeaders: headersConfig,
                withCredentials: false,
            });
            return next.handle(request);
        } else {
            return next.handle(req);
        }
    }
}
